export var RelationshipSummaryStatusType = /*#__PURE__*/ function(RelationshipSummaryStatusType) {
    RelationshipSummaryStatusType["AdHoc"] = "adHoc";
    return RelationshipSummaryStatusType;
}({});
export var AgreementStatus = /*#__PURE__*/ function(AgreementStatus) {
    AgreementStatus["Active"] = "active";
    AgreementStatus["Exhausted"] = "exhausted";
    AgreementStatus["Terminated"] = "terminated";
    return AgreementStatus;
}({});
